<template>
    <div>
        <el-form ref="form" :inline="true" :model="searcheModel">
            <el-form-item label="申请时间">
                <el-date-picker
                    size="small"
                    v-model="searcheModel.apply_time"
                    type="daterange"
                    format="yyyy-MM-dd"
                    value-format="yyyy-MM-dd"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                >
                </el-date-picker>
            </el-form-item>
            <el-form-item label="所属部门">
                <UserCascader
                    v-model="searcheModel.branch_id"
                    ref="branch"
                    :isBusiness="true"
                    @change="changeBranch"
                ></UserCascader>
            </el-form-item>
            <el-form-item label="业务员">
                <OrderUserSelect ref="user" :uid="searcheModel.user_id" @change="CorpHandleChange" clearable></OrderUserSelect>
            </el-form-item>
            <el-form-item label="业务员状态">
                <el-select size="small" v-model="searcheModel.user_status" placeholder="请选择">
                    <el-option label="不限" value=""></el-option>
                    <el-option label="正常" value="1"></el-option>
                    <el-option label="禁用" value="0"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="订单类型">
                <el-select size="small" v-model="searcheModel.order_type" placeholder="请选择">
                    <el-option label="不限" value=""></el-option>
                    <el-option label="试用" value="1"></el-option>
                    <el-option label="正式(新单)" value="2"></el-option>
                    <el-option label="正式(续单)" value="3"></el-option>
                    <el-option label="正式" value="4"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="来源" prop="source">
                <ChannelCascader ref="channelCascader" :channel="channel" @change="channelHandleChange"></ChannelCascader>
            </el-form-item>
            <el-form-item label="申请产品">
                <Product ref="product" :product_id="searcheModel.product_id"
                @change="productChange"></Product>
            </el-form-item>
            <DistrictLinkage ref="DistrictLinkage" :provinceId="searcheModel.province_id" :cityId="searcheModel.city_id" :districtId="searcheModel.district_id" @change="handleChange"></DistrictLinkage>
            <el-form-item>
                <el-button type="primary" size="small" @click="submitSearch" :loading="loading">搜索</el-button>
                <el-button @click="resetForm()" size="small" :loading="loading">重置</el-button>
            </el-form-item>
        </el-form>
        <el-tabs type="card" v-model="searcheModel.count_type" @tab-click="countTypeClick">
            <el-tab-pane label="按部门" name="1"></el-tab-pane>
            <el-tab-pane label="按成员" name="2"></el-tab-pane>
        </el-tabs>
        <el-collapse v-model="collapses" @change="collapseHandleChange">
            <el-collapse-item :name="1">
                <template slot="title">
                    线索概览
                    <ExportFile 
                    url="/api/export/sales-overview" 
                    :params="searcheModel" 
                    filename="线索概览" 
                    buttonName="导出Excel"
                    @click.native.stop>
                    </ExportFile>
                </template>
                <el-table
                    v-loading="loading" 
                    :data="list" 
                    border 
                    :header-cell-style="{background: '#f3faff'}"
                >
                    <el-table-column prop="total_count" label="线索总数"></el-table-column>
                    <el-table-column prop="count_num" label="申请线索数"></el-table-column>
                    <el-table-column prop="flag_leads_num" label="已标记线索数"></el-table-column>
                    <el-table-column prop="valid_flag_leads_num" label="有效标记线索数"></el-table-column>
                    <el-table-column prop="bind_customer_leads_num" label="关联客户线索数"></el-table-column>
                    <el-table-column prop="bind_customer_num" label="关联客户数"></el-table-column>
                    <el-table-column prop="try_customer_num" label="关联客户试用数"></el-table-column>
                    <el-table-column prop="deep_try_customer_num" label="有效试用客户数"></el-table-column>
                    <el-table-column prop="pfm_customer_num" label="关联新增客户数" sortable></el-table-column>
                    <el-table-column prop="renew_customer_num" label="关联续费客户数" sortable></el-table-column>
                    <el-table-column prop="deal_customer_num" label="关联客户成交数"></el-table-column>
                    <el-table-column prop="two_deal_customer_num">
                        <template slot="header">
                            <!-- 自定义表头 -->
                            <span>关联客户二次开发数</span>
                            <el-tooltip class="item" effect="dark" content="线索作为正式订单的客户联系人，且成交了新产品的客户数量" placement="top">
                                <i class="el-icon-info"></i>
                            </el-tooltip>
                        </template>
                        <template slot-scope="scope">
                            {{ scope.row.two_deal_customer_num }}
                        </template>
                    </el-table-column>
                    <el-table-column prop="try_order_num" label="关联试用订单数"></el-table-column>
                    <el-table-column prop="pfm_order_num" label="关联成交正式(新单)订单数"></el-table-column>
                    <el-table-column prop="renew_order_num" label="关联成交正式(续费)订单数"></el-table-column>
                    <el-table-column prop="pfm_amount" label="新增业绩金额"></el-table-column>
                    <el-table-column prop="renew_amount" label="续费业绩金额"></el-table-column>
                    <el-table-column prop="total_amount" label="关联成交销售额"></el-table-column>
                </el-table>
            </el-collapse-item>
            <el-collapse-item :name="2">
                <template slot="title">
                    业务员线索跟进情况
                    <ExportFile 
                    url="/api/export/sales-traces" 
                    :params="searcheModel" 
                    filename="业务员线索跟进情况" 
                    buttonName="导出Excel"
                    @click.native.stop>
                    </ExportFile>
                </template>
                <el-table
                    v-loading="traces_loading" 
                    :data="traces_list" 
                    border 
                    row-key="id" 
                    :tree-props="{children: 'children', hasChildren: 'hasChildren'}"
                    max-height="500"
                    :header-cell-style="{background: '#f3faff'}"
                    show-summary
                >
                    <template v-if="searcheModel.count_type == 1">
                        <el-table-column prop="name" label="部门" width="200"></el-table-column>
                        <el-table-column prop="leader_name" label="部门负责人"></el-table-column>
                    </template>
                    <template v-else>
                        <el-table-column prop="name" label="业务员"></el-table-column>
                        <el-table-column prop="branch_name" label="所属部门"></el-table-column>
                    </template>
                    <el-table-column prop="count_num" label="已绑线索数"></el-table-column>
                    <el-table-column prop="flag_leads_num" label="已标记线索数"></el-table-column>
                    <el-table-column prop="valid_flag_leads_num" label="有效标记线索数"></el-table-column>
                    <el-table-column prop="bind_customer_leads_num" label="关联客户线索数"></el-table-column>
                    <el-table-column prop="bind_customer_num" label="关联客户数"></el-table-column>
                    <el-table-column prop="try_customer_num" label="关联客户试用数"></el-table-column>
                    <el-table-column prop="deep_try_customer_num" label="有效试用客户数"></el-table-column>
                    <el-table-column prop="pfm_customer_num" label="关联新增客户数" sortable></el-table-column>
                    <el-table-column prop="renew_customer_num" label="关联续费客户数" sortable></el-table-column>
                    <el-table-column prop="deal_customer_num" label="关联客户成交数"></el-table-column>
                    <el-table-column prop="first_order_avg">
                        <template slot="header">
                            <!-- 自定义表头 -->
                            <span>平均成交时长(天)</span>
                            <el-tooltip class="item" effect="dark" content="所有（关联客户首次创建新单时间-线索绑定时间）之和/成交客户数 " placement="top">
                                <i class="el-icon-info"></i>
                            </el-tooltip>
                        </template>
                        <template slot-scope="scope">
                            {{ scope.row.first_order_avg }}
                        </template>
                    </el-table-column>
                    <el-table-column prop="try_order_num" label="关联试用订单数"></el-table-column>
                    <el-table-column prop="pfm_order_num" label="关联成交正式(新单)订单数"></el-table-column>
                    <el-table-column prop="renew_order_num" label="关联成交正式(续费)订单数"></el-table-column>
                    <el-table-column prop="pfm_amount" label="新增业绩金额"></el-table-column>
                    <el-table-column prop="renew_amount" label="续费业绩金额"></el-table-column>
                    <el-table-column prop="total_amount" label="关联成交销售额"></el-table-column>
                </el-table>
            </el-collapse-item>
            <el-collapse-item :name="7">
                <template slot="title">
                    接收线索转化分析
                    <ExportFile 
                    url="/api/export/sales-receive" 
                    :params="searcheModel" 
                    filename="接收线索转化分析" 
                    buttonName="导出Excel"
                    @click.native.stop>
                    </ExportFile>
                </template>
                <el-table
                    v-loading="receive_loading" 
                    :data="receive_list" 
                    border 
                    row-key="id" 
                    :tree-props="{children: 'children', hasChildren: 'hasChildren'}" 
                    max-height="500" 
                    :header-cell-style="{background: '#f3faff'}" 
                    show-summary 
                >
                    <template v-if="searcheModel.count_type == 1">
                        <el-table-column prop="name" label="部门" width="200"></el-table-column>
                        <el-table-column prop="leader_name" label="部门负责人"></el-table-column>
                    </template>
                    <template v-else>
                        <el-table-column prop="name" label="业务员"></el-table-column>
                        <el-table-column prop="branch_name" label="所属部门"></el-table-column>
                    </template>
                    <el-table-column prop="count_num" label="接收线索数"></el-table-column>
                    <el-table-column prop="flag_leads_num" label="已标记线索数"></el-table-column>
                    <el-table-column prop="valid_flag_leads_num" label="有效标记线索数"></el-table-column>
                    <el-table-column prop="bind_customer_leads_num" label="关联客户线索数"></el-table-column>
                    <el-table-column prop="bind_customer_num" label="关联客户数"></el-table-column>
                    <el-table-column prop="try_customer_num" label="关联客户试用数"></el-table-column>
                    <el-table-column prop="deep_try_customer_num" label="有效试用客户数"></el-table-column>
                    <el-table-column prop="pfm_customer_num" label="关联新增客户数" sortable></el-table-column>
                    <el-table-column prop="renew_customer_num" label="关联续费客户数" sortable></el-table-column>
                    <el-table-column prop="deal_customer_num" label="关联客户成交数"></el-table-column>
                    <el-table-column prop="two_deal_customer_num">
                        <template slot="header">
                            <!-- 自定义表头 -->
                            <span>关联客户二次开发数</span>
                            <el-tooltip class="item" effect="dark" content="线索作为正式订单的客户联系人，且成交了新产品的客户数量" placement="top">
                                <i class="el-icon-info"></i>
                            </el-tooltip>
                        </template>
                        <template slot-scope="scope">
                            {{ scope.row.two_deal_customer_num }}
                        </template>
                    </el-table-column>
                    <el-table-column prop="try_order_num" label="关联试用订单数"></el-table-column>
                    <el-table-column prop="pfm_order_num" label="关联成交正式(新单)订单数"></el-table-column>
                    <el-table-column prop="renew_order_num" label="关联成交正式(续费)订单数"></el-table-column>
                    <el-table-column prop="pfm_amount" label="新增业绩金额"></el-table-column>
                    <el-table-column prop="renew_amount" label="续费业绩金额"></el-table-column>
                    <el-table-column prop="total_amount" label="关联成交销售额"></el-table-column>
                    <el-table-column prop="deal_customer_ratio">
                        <template slot="header">
                            <!-- 自定义表头 -->
                            <span>关联新增客户转化率</span>
                            <el-tooltip class="item" effect="dark" content="关联新增客户数➗关联客户数" placement="top">
                                <i class="el-icon-info"></i>
                            </el-tooltip>
                        </template>
                        <template slot-scope="scope">
                            {{ scope.row.deal_customer_ratio + '%' }}
                        </template>
                    </el-table-column>
                </el-table>
            </el-collapse-item>
            <el-collapse-item :name="3">
                <template slot="title">
                    线索地区转化分布
                    <ExportFile 
                    url="/api/export/sales-area" 
                    :params="searcheModel" 
                    filename="线索地区转化分布" 
                    buttonName="导出Excel"
                    @click.native.stop>
                    </ExportFile>
                </template>
                <el-table
                    v-loading="area_loading" 
                    :data="area_list"
                    max-height="500"
                    row-key="id"
                    border
                    lazy
                    :load="loadArea"
                    :tree-props="{children: 'children', hasChildren: 'hasChildren'}"
                    show-summary>
                    <el-table-column prop="name" label="地区" width="180"></el-table-column>
                    <el-table-column prop="count_num" label="申请线索数" sortable></el-table-column>
                    <el-table-column prop="flag_leads_num" label="已标记线索数" sortable></el-table-column>
                    <el-table-column prop="valid_flag_leads_num" label="有效标记线索数"></el-table-column>
                    <el-table-column prop="bind_customer_leads_num" label="关联客户线索数" sortable></el-table-column>
                    <el-table-column prop="bind_customer_num" label="关联客户数" sortable></el-table-column>
                    <el-table-column prop="try_customer_num" label="关联客户试用数" sortable></el-table-column>
                    <el-table-column prop="deep_try_customer_num" label="有效试用客户数" sortable></el-table-column>
                    <el-table-column prop="pfm_customer_num" label="关联新增客户数" sortable></el-table-column>
                    <el-table-column prop="renew_customer_num" label="关联续费客户数" sortable></el-table-column>
                    <el-table-column prop="deal_customer_num" label="关联客户成交数" sortable></el-table-column>
                    <el-table-column prop="first_order_avg" sortable>
                        <template slot="header">
                            <span>平均成交时长(天)</span>
                            <el-tooltip class="item" effect="dark" content="所有（关联客户首次创建新单时间-线索绑定时间）之和/成交客户数 " placement="top">
                                <i class="el-icon-info"></i>
                            </el-tooltip>
                        </template>
                        <template slot-scope="scope">
                            {{ scope.row.first_order_avg }}
                        </template>
                    </el-table-column>
                    <el-table-column prop="try_order_num" label="关联试用订单数" sortable></el-table-column>
                    <el-table-column prop="pfm_order_num" label="关联成交正式(新单)订单数" sortable></el-table-column>
                    <el-table-column prop="renew_order_num" label="关联成交正式(续费)订单数" sortable></el-table-column>
                    <el-table-column prop="pfm_amount" label="新增业绩金额"></el-table-column>
                    <el-table-column prop="renew_amount" label="续费业绩金额"></el-table-column>
                    <el-table-column prop="total_amount" label="关联成交销售额" sortable></el-table-column>
                </el-table>
            </el-collapse-item>
            <el-collapse-item :name="4">
                <template slot="title">
                    线索来源转化分布
                    <ExportFile 
                    url="/api/export/sales-source" 
                    :params="searcheModel" 
                    filename="线索来源转化分布" 
                    buttonName="导出Excel"
                    @click.native.stop>
                    </ExportFile>
                </template>
                <el-table
                    v-loading="source_loading" 
                    :data="source_list"
                    border
                    row-key="id" 
                    :tree-props="{children: 'children', hasChildren: 'hasChildren'}"
                    max-height="500"
                    show-summary>
                    <el-table-column prop="name" label="来源" width="180"></el-table-column>
                    <el-table-column prop="product_name" label="所属产品"></el-table-column>
                    <el-table-column prop="count_num" label="申请线索数" sortable></el-table-column>
                    <el-table-column prop="flag_leads_num" label="已标记线索数" sortable></el-table-column>
                    <el-table-column prop="valid_flag_leads_num" label="有效标记线索数"></el-table-column>
                    <el-table-column prop="bind_customer_leads_num" label="关联客户线索数" sortable></el-table-column>
                    <el-table-column prop="bind_customer_num" label="关联客户数" sortable></el-table-column>
                    <el-table-column prop="try_customer_num" label="关联客户试用数" sortable></el-table-column>
                    <el-table-column prop="deep_try_customer_num" label="有效试用客户数" sortable></el-table-column>
                    <el-table-column prop="pfm_customer_num" label="关联新增客户数" sortable></el-table-column>
                    <el-table-column prop="renew_customer_num" label="关联续费客户数" sortable></el-table-column>
                    <el-table-column prop="deal_customer_num" label="关联客户成交数" sortable></el-table-column>
                    <el-table-column prop="try_order_num" label="关联试用订单数" sortable></el-table-column>
                    <el-table-column prop="pfm_order_num" label="关联成交正式(新单)订单数" sortable></el-table-column>
                    <el-table-column prop="renew_order_num" label="关联成交正式(续费)订单数" sortable></el-table-column>
                    <el-table-column prop="pfm_amount" label="新增业绩金额"></el-table-column>
                    <el-table-column prop="renew_amount" label="续费业绩金额"></el-table-column>
                    <el-table-column prop="total_amount" label="关联成交销售额" sortable></el-table-column>
                    <el-table-column prop="deal_customer_ratio" sortable>
                        <template slot="header">
                            <!-- 自定义表头 -->
                            <span>关联新增客户转化率</span>
                            <el-tooltip class="item" effect="dark" content="关联新增客户数➗关联客户数" placement="top">
                                <i class="el-icon-info"></i>
                            </el-tooltip>
                        </template>
                        <template slot-scope="scope">
                            {{ scope.row.deal_customer_ratio + '%' }}
                        </template>
                    </el-table-column>
                </el-table>
            </el-collapse-item>
            <el-collapse-item :name="5">
                <template slot="title">
                    线索学段转化分布
                    <ExportFile 
                    url="/api/export/sales-xueduan" 
                    :params="searcheModel" 
                    filename="线索学段转化分布" 
                    buttonName="导出Excel"
                    @click.native.stop>
                    </ExportFile>
                </template>
                <el-table
                    v-loading="xueduan_loading" 
                    :data="xueduan_list"
                    border
                    max-height="500"
                    show-summary>
                    <el-table-column prop="name" label="学段"></el-table-column>
                    <el-table-column prop="bind_customer_leads_num" label="关联客户线索数" sortable></el-table-column>
                    <el-table-column prop="bind_customer_num" label="关联客户数" sortable></el-table-column>
                    <el-table-column prop="try_customer_num" label="关联客户试用数" sortable></el-table-column>
                    <el-table-column prop="deep_try_customer_num" label="有效试用客户数" sortable></el-table-column>
                    <el-table-column prop="pfm_customer_num" label="关联新增客户数" sortable></el-table-column>
                    <el-table-column prop="renew_customer_num" label="关联续费客户数" sortable></el-table-column>
                    <el-table-column prop="deal_customer_num" label="关联客户成交数" sortable></el-table-column>
                    <el-table-column prop="try_order_num" label="关联试用订单数" sortable></el-table-column>
                    <el-table-column prop="pfm_order_num" label="关联成交正式(新单)订单数" sortable></el-table-column>
                    <el-table-column prop="renew_order_num" label="关联成交正式(续费)订单数" sortable></el-table-column>
                    <el-table-column prop="pfm_amount" label="新增业绩金额"></el-table-column>
                    <el-table-column prop="renew_amount" label="续费业绩金额"></el-table-column>
                    <el-table-column prop="total_amount" label="关联成交销售额" sortable></el-table-column>
                </el-table>
            </el-collapse-item>
            <el-collapse-item :name="6">
                <template slot="title">
                    线索跟进时效
                    <ExportFile 
                    url="/api/export/sales-validity" 
                    :params="searcheModel" 
                    filename="线索跟进时效" 
                    buttonName="导出Excel"
                    @click.native.stop>
                    </ExportFile>
                </template>
                <el-table
                    v-loading="validity_loading" 
                    :data="validity_list" 
                    border 
                    row-key="id" 
                    :tree-props="{children: 'children', hasChildren: 'hasChildren'}"
                    max-height="500"
                    :header-cell-style="{background: '#f3faff'}"
                    show-summary
                >
                    <template v-if="searcheModel.count_type == 1">
                        <el-table-column prop="name" label="部门" width="200"></el-table-column>
                        <el-table-column prop="leader_name" label="部门负责人"></el-table-column>
                    </template>
                    <template v-else>
                        <el-table-column prop="name" label="业务员"></el-table-column>
                        <el-table-column prop="branch_name" label="所属部门"></el-table-column>
                    </template>
                    <el-table-column prop="count_num" label="接收线索数">
                        <template slot-scope="scope">
                            <el-button type="text" @click="dialogShow(scope.row, 1)">
                                {{ scope.row.count_num }}
                            </el-button>
                        </template>
                    </el-table-column>
                    <!-- <el-table-column prop="unbind_and_transfer_num" label="已解绑/转交线索数">
                        <template slot-scope="scope">
                            <el-button type="text" @click="dialogShow(scope.row, 2)">
                                {{ scope.row.unbind_and_transfer_num }}
                            </el-button>
                        </template>
                    </el-table-column> -->
                    <el-table-column prop="three_num" label="0-3小时跟进"></el-table-column>
                    <el-table-column prop="twelve_num" label="3-12小时跟进"></el-table-column>
                    <el-table-column prop="twenty_four_num" label="12-24小时跟进"></el-table-column>
                    <el-table-column prop="overtime_num" label="超24小时跟进"></el-table-column>
                    <el-table-column prop="three_ratio" label="3小时内跟进率">
                        <template slot-scope="scope">
                            {{scope.row.three_ratio + '%'}}
                        </template>
                    </el-table-column>
                    <el-table-column prop="trace_ratio" label="跟进率">
                        <template slot-scope="scope">
                            {{scope.row.trace_ratio + '%'}}
                        </template>
                    </el-table-column>
                    <!-- <el-table-column prop="not_trace_ratio" label="未跟进率">
                        <template slot-scope="scope">
                            {{scope.row.not_trace_ratio + '%'}}
                        </template>
                    </el-table-column> -->
                </el-table>
            </el-collapse-item>
        </el-collapse>

        <ValidityDialog v-if="dialogTableVisible" :params="params" :type="dialogType" :title="dialogTitle" @close="closeDialog"></ValidityDialog>
    </div>
</template>
<script>
import ClueCount from "~/services/ClueCount";
import UserCascader from "~/widgets/UserCascader.vue";
import OrderUserSelect from "~/widgets/OrderUserSelect.vue";
import Product from "~/widgets/Product.vue";
import ChannelCascader from "~/widgets/ChannelCascader.vue";
import DistrictLinkage from "~/widgets/DistrictLinkage.vue";
import ExportFile from "~/widgets/ExportFile.vue";
import Config from "~/config/params";
import TryConvOrderDialog from "~/views/count/dialog/TryConvOrderDialog.vue";
import ValidityDialog from "~/views/count/dialog/ValidityDialog.vue";
export default{
    name: 'conversion',
    
    components: {
        UserCascader,
        OrderUserSelect,
        Product,
        ChannelCascader,
        DistrictLinkage,
        ExportFile,
        Config,
        TryConvOrderDialog,
        ValidityDialog
    },

    data() {
        return {
            loading: false,
            list: [],

            traces_loading: false,
            traces_list: [],

            area_loading: false,
            area_list: [],

            source_loading: false,
            source_list: [],

            xueduan_loading: false,
            xueduan_list: [],

            validity_loading: false,
            validity_list: [],

            receive_loading: false,
            receive_list: [],

            searcheModel: {},
            collapses: [1, 2],
            collapse_length: 2,
            channel: {
                pid: 0,
                id: 0,
            },

            dialogTableVisible: false,
            dialogType: 1,
            dialogTitle: '接收线索详情',
            params: {},
        };
    },

    created(){
        this.resetForm();
    },
    
    methods: {

        //重置按钮
        resetForm() {
            this.searcheModel = {
                branch_id: "",
                user_id: "",
                apply_time: Config.getDataTimes('to_day'),
                product_id: '',
                order_type: '',
                source: '',
                province_id: 0,
                city_id: 0,
                district_id: 0,
                sort_name: '',
                sort_by: '',
                count_type: '1',
                user_status: '1',
            };
            if(this.$refs['branch']){
                this.$refs['branch'].reset();
            }
            if(this.$refs['user']){
                this.$refs['user'].reset();
            }
            if(this.$refs['product']){
                this.$refs['product'].reset();
            }
            if(this.$refs['channelCascader']){
                this.$refs['channelCascader'].reset();
            }
            this.list = [];
            this.submitSearch();
        },

        // 筛选查询
        submitSearch($data = null, collapse_name = null) {
            if($data && typeof $data.order !== undefined){
                this.searcheModel.sort_name = $data['prop'];
                this.searcheModel.sort_by = $data['order'];
            }
            let params = _.clone(this.searcheModel);
            _.each(params, (val, key) => {
                // 如果值是假值，除了数字 0 和字符串 '0'，都删除该键
                if (val === undefined || val === null || (typeof val === 'string' && val === '')) {
                    delete params[key];
                }
            })
            if (!collapse_name && this.collapses.includes(1) || collapse_name == 1){
                this.getList(params);
            }
            if (!collapse_name && this.collapses.includes(2) || collapse_name == 2){
                this.getTracesList(params);
            }
            if (!collapse_name && this.collapses.includes(3) || collapse_name == 3){
                this.getAreaList(params);
            }
            if (!collapse_name && this.collapses.includes(4) || collapse_name == 4){
                this.getSourceList(params);
            }
            if (!collapse_name && this.collapses.includes(5) || collapse_name == 5){
                this.getXueduanList(params);
            }
            if (!collapse_name && this.collapses.includes(6) || collapse_name == 6){
                this.getValidityList(params);
            }
            if (!collapse_name && this.collapses.includes(7) || collapse_name == 7){
                this.getReceiveList(params);
            }
        },

        //获取列表
        getList(params) {
            // loading 动画
            this.loading = true;
            this.list = [];
            ClueCount.getList(params, 'overview')
            .then((res) => {
                if (res.code == 0) {
                    this.list = res.data;
                }
                this.loading = false;
            })
            .catch((err) => {
                console.error(err);
                this.loading = false;
            });
        },

        //跟进情况列表
        getTracesList(params) {
            // loading 动画
            this.traces_loading = true;
            this.traces_list = [];
            ClueCount.getList(params, 'traces')
            .then((res) => {
                if (res.code == 0) {
                    this.traces_list = res.data;
                }
                this.traces_loading = false;
            })
            .catch((err) => {
                console.error(err);
                this.traces_loading = false;
            });
        },

        //地区情况列表
        getAreaList(params) {
            // loading 动画
            this.area_loading = true;
            this.area_list = [];
            ClueCount.getList(params, 'area')
            .then((res) => {
                if (res.code == 0) {
                    this.area_list = res.data;
                }
                this.area_loading = false;
            })
            .catch((err) => {
                console.error(err);
                this.area_loading = false;
            });
        },

        //来源情况列表
        getSourceList(params) {
            // loading 动画
            this.source_loading = true;
            this.source_list = [];
            ClueCount.getList(params, 'source')
            .then((res) => {
                if (res.code == 0) {
                    this.source_list = res.data;
                }
                this.source_loading = false;
            })
            .catch((err) => {
                console.error(err);
                this.source_loading = false;
            });
        },

        //学段情况列表
        getXueduanList(params) {
            // loading 动画
            this.xueduan_loading = true;
            this.xueduan_list = [];
            ClueCount.getList(params, 'xueduan')
            .then((res) => {
                if (res.code == 0) {
                    this.xueduan_list = res.data;
                }
                this.xueduan_loading = false;
            })
            .catch((err) => {
                console.error(err);
                this.xueduan_loading = false;
            });
        },

        //跟进情况列表
        getValidityList(params) {
            // loading 动画
            this.validity_loading = true;
            this.validity_list = [];
            ClueCount.getList(params, 'validity')
            .then((res) => {
                if (res.code == 0) {
                    this.validity_list = res.data;
                }
                this.validity_loading = false;
            })
            .catch((err) => {
                console.error(err);
                this.validity_loading = false;
            });
        },

        getReceiveList(params){
            // loading 动画
            this.receive_loading = true;
            this.receive_list = [];
            ClueCount.getList(params, 'receive')
            .then((res) => {
                if (res.code == 0) {
                    this.receive_list = res.data;
                }
                this.receive_loading = false;
            })
            .catch((err) => {
                console.error(err);
                this.receive_loading = false;
            });
        },
        
        loadArea(tree, treeNode, resolve){
            // console.log(tree, treeNode, resolve);
            let params = _.clone(this.searcheModel);
            _.each(params, (val, key) => {
                // 如果值是假值，除了数字 0 和字符串 '0'，都删除该键
                if (val === undefined || val === null || (typeof val === 'string' && val === '')) {
                    delete params[key];
                }
            })
            if(tree.level == 1){
                params.province_id = tree.province_id;
            }else if(tree.level == 2){
                params.city_id = tree.city_id;
            }
            ClueCount.getList(params, 'area')
            .then((res) => {
                if (res.code == 0) {
                    resolve(res.data)
                }
            })
            .catch((err) => {
                console.error(err);
            });
        },

        //切换部门子组件
        changeBranch(value) {
            if (value.length > 0) {
                // 取得最后一级部门作为所属部门
                this.searcheModel.branch_id = value[value.length - 1];
            } else {
                this.searcheModel.branch_id = "";
            }
        },

        CorpHandleChange($event){
            this.searcheModel.user_id = $event.id;
        },

        productChange(value) {
            this.searcheModel.product_id = value;
        },

        //切换运营渠道子组件
        channelHandleChange(value) {
            // console.log("运营渠道：", value);
            if (value && value.length > 0) {
            this.searcheModel.source = value[value.length - 1].toString();
            this.channel = {
                pid: value.length == 2 ? value[0] : 0,
                id: value[value.length - 1],
            };
            } else {
            this.searcheModel.source = "";
            this.channel = _.clone(
                _.extend(this.searcheModel, {
                pid: "",
                id: "",
                })
            );
            }
        },

        //地区联动 Cascader 级联选择器,切换事件,表单model赋值
        handleChange(value) {
            this.searcheModel.province_id = parseInt(value[0]);
            this.searcheModel.city_id = parseInt(value[1]);
            this.searcheModel.district_id = parseInt(value[2]);
        },

        collapseHandleChange(val) {
            if(val && val.length > this.collapse_length){
                const clicked_name = val[val.length - 1];
                this.submitSearch(null, clicked_name);
            }
            this.collapse_length = val.length;
        },

        countTypeClick(){
            this.submitSearch();
        },

        dialogShow(row, type){
            this.params = _.clone(this.searcheModel);
            if(row.hasOwnProperty('user_id')){
                this.params['user_id'] = row.user_id;
                this.params['branch_id'] = row.branch_id;
            }else{
                this.params['branch_id'] = row.branch_id;
            }
            this.dialogType = this.params['validity_type'] = type;
            if(this.dialogType == 2) this.dialogTitle = '解绑/转交线索详情';
            else this.dialogTitle = '接收线索详情';
            this.dialogTableVisible = true;
            // console.log(this.dialogType, this.dialogTitle);
        },

        closeDialog(){
            this.dialogTableVisible = false;
            this.params = [];
        },
    }
}
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/count/clue/conversion.vue